export default class SavedSet {
  /**
   * @param {string} setName
   * @param {string} memberName
   * @param {boolean} isMember
   */
  static setMembership(setName, memberName, isMember) {
    if (typeof memberName === 'string' || memberName instanceof String) {
      /** @type {Array<string>} */
      const set = (window.localStorage.getItem(setName) || '')
        .split(',')
        .filter(e => e.length > 0);
      if (isMember) {
        // Add if we're not part of it
        if (set.indexOf(memberName) === -1) {
          set.push(memberName);
        }
      } else {
        // Remove if we're part of it
        if (set.indexOf(memberName) !== -1) {
          set.splice(set.indexOf(memberName), 1);
        }
      }
      window.localStorage.setItem(setName, set.join(','));
    } else {
      try {
        throw new Error(
          `SavedSet.setMembership() called with non-string member (${typeof memberName}): ${memberName}`
        );
      } catch (e) {
        console.error(e);
      }
    }
  }

  /**
   * @param {string} setName
   * @param {string} memberName
   * @returns {boolean}
   */
  static isMember(setName, memberName) {
    if (typeof memberName === 'string' || memberName instanceof String) {
      memberName = memberName.toString();
      /** @type {Array<string>} */
      const set = (window.localStorage.getItem(setName) || '')
        .split(',')
        .filter(e => e.length > 0);
      return set.indexOf(memberName) !== -1;
    }
    try {
      throw new Error(
        `SavedSet.isMember() called with non-string member (${typeof memberName}): ${memberName}`
      );
    } catch (e) {
      console.error(e);
    }
    return false;
  }

  /**
   * @param {string} setName
   */
  static clearSet(setName) {
    window.localStorage.setItem(setName, '');
  }

  /**
   * @param {string} setName
   * @returns {Array<string>}
   */
  static getSetContents(setName) {
    return (window.localStorage.getItem(setName) || '')
      .split(',')
      .filter(e => e.length > 0);
  }
}
